var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 15,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dealer's Application"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-22534 -4657C-22534 -4658.1 -22533.1 -4659 -22532 -4659H18856C18857.1 -4659 18858 -4658.1 18858 -4657V34214C18858 34215.1 18857.1 34216 18856 34216H-22532C-22533.1 34216 -22534 34215.1 -22534 34214V-4657Z",
    fill: "#FAEFDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22532 -4658H18856V-4660H-22532V-4658ZM18857 -4657V34214H18859V-4657H18857ZM18856 34215H-22532V34217H18856V34215ZM-22533 34214V-4657H-22535V34214H-22533ZM-22532 34215C-22532.6 34215 -22533 34214.6 -22533 34214H-22535C-22535 34215.7 -22533.7 34217 -22532 34217V34215ZM18857 34214C18857 34214.6 18856.6 34215 18856 34215V34217C18857.7 34217 18859 34215.7 18859 34214H18857ZM18856 -4658C18856.6 -4658 18857 -4657.55 18857 -4657H18859C18859 -4658.66 18857.7 -4660 18856 -4660V-4658ZM-22532 -4660C-22533.7 -4660 -22535 -4658.66 -22535 -4657H-22533C-22533 -4657.55 -22532.6 -4658 -22532 -4658V-4660Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "View Application"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1048 -1634C-1048 -1635.1 -1047.1 -1636 -1046 -1636H18281C18282.1 -1636 18283 -1635.1 18283 -1634V6551C18283 6552.1 18282.1 6553 18281 6553H-1046C-1047.1 6553 -1048 6552.1 -1048 6551V-1634Z",
    fill: "#FFFEDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1046 -1635H18281V-1637H-1046V-1635ZM18282 -1634V6551H18284V-1634H18282ZM18281 6552H-1046V6554H18281V6552ZM-1047 6551V-1634H-1049V6551H-1047ZM-1046 6552C-1046.55 6552 -1047 6551.55 -1047 6551H-1049C-1049 6552.66 -1047.66 6554 -1046 6554V6552ZM18282 6551C18282 6551.55 18281.6 6552 18281 6552V6554C18282.7 6554 18284 6552.66 18284 6551H18282ZM18281 -1635C18281.6 -1635 18282 -1634.55 18282 -1634H18284C18284 -1635.66 18282.7 -1637 18281 -1637V-1635ZM-1046 -1637C-1047.66 -1637 -1049 -1635.66 -1049 -1634H-1047C-1047 -1634.55 -1046.55 -1635 -1046 -1635V-1637Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "View Application - Overview",
    clipPath: "url(#clip0_7535_17615)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1437,
    height: 1772,
    transform: "translate(-755 -364)",
    fill: "#E37617"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M-675 -364H682V1408H-675V-364Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sheet",
    filter: "url(#filter0_d_7535_17615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-639 -166C-639 -168.761 -636.761 -171 -634 -171H646C648.761 -171 651 -168.761 651 -166V24C651 26.7614 648.761 29 646 29H-634C-636.761 29 -639 26.7614 -639 24V-166Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Utility Icons / C / chevrondown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 415"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8197 1.55293L7.23193 7.19518C7.06838 7.35873 6.79581 7.35873 6.63227 7.19518L1.04453 1.55293C0.880989 1.38939 0.880989 1.11682 1.04453 0.953274L1.64419 0.353615C1.80774 0.190071 2.08031 0.190071 2.24385 0.353615L6.63227 4.79654C6.79581 4.96009 7.06838 4.96009 7.23193 4.79654L11.6203 0.380872C11.7839 0.217328 12.0565 0.217328 12.22 0.380872L12.8197 0.980531C12.9559 1.14407 12.9559 1.38939 12.8197 1.55293Z",
    fill: "#661C69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8197 7.63985L7.23193 13.2821C7.06838 13.4456 6.79581 13.4456 6.63227 13.2821L1.04453 7.63985C0.880989 7.4763 0.880989 7.20373 1.04453 7.04019L1.64419 6.44053C1.80774 6.27699 2.08031 6.27699 2.24385 6.44053L6.63227 10.8835C6.79581 11.047 7.06838 11.047 7.23193 10.8835L11.6203 6.46779C11.7839 6.30424 12.0565 6.30424 12.22 6.46779L12.8197 7.06745C12.9559 7.23099 12.9559 7.4763 12.8197 7.63985Z",
    fill: "#661C69"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7535_17615",
    x: -651,
    y: -175,
    width: 1314,
    height: 224,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7535_17615"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7535_17615",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7535_17615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1437,
    height: 1772,
    fill: "white",
    transform: "translate(-755 -364)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/ChevronDown.0e29b51bbc6233343bd903a410864cd9.svg";
export { ForwardRef as ReactComponent };